module.exports = __webpack_public_path__ + "static/media/adversal.2472f670.svg";